import { useHistory } from "react-router-dom";

import { useJsonApi } from "@/modules/api/hooks/useJsonApi";
import { useMutation } from "@/modules/api/hooks/useMutation";
import { apiErrorValidate } from "@/modules/api/utils/apiErrorValidate";
import { forgotPasswordMutation } from "@/modules/auth/api/mutations/forgotPassword/forgotPasswordMutation";
import { anonymousRouting } from "@/modules/router/routings/anonymousRouting";

export const useForgotPasswordMutation = () => {
  const jsonApi = useJsonApi();
  const history = useHistory();

  return useMutation([forgotPasswordMutation.name], {
    mutationFn: forgotPasswordMutation(jsonApi),
    onSuccess: () => {
      history.replace(anonymousRouting.buildUrl("resetPasswordConfirmation"));
    },
    onError: (error) => {
      apiErrorValidate(error);
    },
    retry: false,
  });
};
